import { MdDashboard, MdHistory, MdRequestQuote, MdFolderShared } from "react-icons/md";
import { FaRegFolderOpen } from "react-icons/fa6";
import { BiHistory } from "react-icons/bi";
import {
  HiClipboardList,
  HiCheckCircle,
  HiDocumentText,
  HiFolderOpen,
  HiLogin,
  HiLogout,
  HiPlusCircle,
  HiReceiptTax,
  HiOutlineClipboardCheck,
} from "react-icons/hi";

import {
  CHECK_IN,
  CHECK_OUT,
  BACK_DATED,
  ADD_BILL,
  LIST_BILLS,
  DRIVE,
  TASK_PAGE,
  ADD_TASK,
  ATTENDANCE_DASHBOARD_LINK,
  ATTENDANCE_ACTION,
} from "../../routes";

const commonCss = "w-10 h-10 md:w-12 md:h-12";
const subMenuCss = "items-center";

export const SUB_MENU = {
  TASK: [
    {
      title: "Task",
      label: "Add Task",
      icon: (
        <HiPlusCircle className={`${commonCss} text-green-600 ${subMenuCss}`} />
      ),
      link: ADD_TASK,
    },
    {
      title: "Task",
      label: "View Task",
      icon: (
        <MdHistory className={`${commonCss} text-green-600 ${subMenuCss}`} />
      ),
      link: TASK_PAGE,
    },
  ],

  BILL: [
    {
      title: "Bill",
      label: "Add Purchase",
      icon: (
        <HiReceiptTax
          className={`${commonCss} text-yellow-600 ${subMenuCss}`}
        />
      ),
      link: ADD_BILL.replace(":billType", "purchase"),
    },
    {
      title: "Bill",
      label: "Add Reimbursement",
      icon: (
        <MdRequestQuote
          className={`${commonCss} text-yellow-600 ${subMenuCss}`}
        />
      ),
      link: ADD_BILL.replace(":billType", "reimbursement"),
    },
    {
      title: "Bill History",
      label: "View History",
      icon: (
        <MdHistory className={`${commonCss} text-yellow-600 ${subMenuCss}`} />
      ),
      link: LIST_BILLS,
    },
  ],

  ATTENDANCE: [
    {
      title: "Attendance",
      label: "Check-In",
      icon: <HiLogin className={`${commonCss} text-blue-600 ${subMenuCss}`} />,
      link: CHECK_IN,
    },
    {
      title: "Attendance",
      label: "Check-Out",
      icon: <HiLogout className={`${commonCss} text-red-600 ${subMenuCss}`} />,
      link: CHECK_OUT,
    },
    {
      title: "Attendance",
      label: "Backdated Attendance",
      icon: (
        <BiHistory className={`${commonCss} text-green-600 ${subMenuCss}`} />
      ),
      link: BACK_DATED,
    },
    {
      title: "Attendance",
      label: "Dashboard & History",
      icon: (
        <MdDashboard className={`${commonCss} text-yellow-600 ${subMenuCss}`} />
      ),
      link: ATTENDANCE_DASHBOARD_LINK,
    },
    {
      title: "Attendance",
      label: "Attendance Actions",
      icon: (
        <HiOutlineClipboardCheck className={`${commonCss} text-purple-600 ${subMenuCss}`}/>
      ),
      link: ATTENDANCE_ACTION, 
    },
  ],
  FILE: [
    {
      title: "File",
      label: "My Drive",
      icon: (
        <FaRegFolderOpen  className={`${commonCss} text-yellow-400 ${subMenuCss}`} />
      ),
      link: DRIVE.replace(":type", "my"),
    },
    {
      title: "File",
      label: "Shared Drive",
      icon: (
        <MdFolderShared   className={`${commonCss} text-yellow-400 ${subMenuCss}`} />
      ),
      link: DRIVE.replace(":type", "shared"),
    },
  ],
};

export const MENU_ITEMS = [
  {
    label: "Attendance",
    icon: <HiCheckCircle className={`${commonCss} text-white`} />,
    color: "bg-blue-600",
  },
  {
    label: "Task",
    icon: <HiClipboardList className={`${commonCss}`} />,
    color: "bg-green-600",
  },
  {
    label: "Bill",
    icon: <HiDocumentText className={`${commonCss}`} />,
    color: "bg-yellow-600",
  },
  {
    label: "Drive",
    icon: <HiFolderOpen className={`${commonCss}`} />,
    color: "bg-yellow-400",
  },
];

export const QUICK_ACTION_ITEMS = [
  {
    label: "Check-In",
    icon: <HiLogin className={`${commonCss} text-blue-600`} />,
    link: CHECK_IN,
  },
  {
    label: "Check-Out",
    icon: <HiLogout className={`${commonCss} text-red-600`} />,
    link: CHECK_OUT,
  },
  {
    label: "Add Task",
    icon: <HiPlusCircle className={`${commonCss} ext-green-600`} />,
    link: ADD_TASK,
  },
  {
    label: "Add Bill",
    icon: <HiReceiptTax className={`${commonCss} text-yellow-600`} />,
    BillPopUp: true,
  },
];
